import $ from 'jquery';
import 'jquery.maskedinput/src/jquery.maskedinput';
//import MobCheck from '../js/mobile';
import Swiper from 'swiper/swiper-bundle.min';
import 'jquery.appear';
import 'slick-carousel';
import '../js/jquery-ui.min.js';
import '../js/gsap.min.js';
import '../js/ScrollSmoother.min.js';
import '../js/ScrollToPlugin.min.js';
import '../js/ScrollTrigger.min.js';
import videojs from 'video.js';
import Reflect from 'core-js/es6/reflect';

// import { Scrollbar, EffectCreative } from "swiper";

window.$ = window.jQuery = $;

//touch punch
!(function (a) {
  function f(a, b) {
    if (!(a.originalEvent.touches.length > 1)) {
      a.preventDefault();
      var c = a.originalEvent.changedTouches[0],
        d = document.createEvent('MouseEvents');
      d.initMouseEvent(b, !0, !0, window, 1, c.screenX, c.screenY, c.clientX, c.clientY, !1, !1, !1, !1, 0, null), a.target.dispatchEvent(d);
    }
  }
  if (((a.support.touch = 'ontouchend' in document), a.support.touch)) {
    var e,
      b = a.ui.mouse.prototype,
      c = b._mouseInit,
      d = b._mouseDestroy;
    (b._touchStart = function (a) {
      var b = this;
      !e && b._mouseCapture(a.originalEvent.changedTouches[0]) && ((e = !0), (b._touchMoved = !1), f(a, 'mouseover'), f(a, 'mousemove'), f(a, 'mousedown'));
    }),
      (b._touchMove = function (a) {
        e && ((this._touchMoved = !0), f(a, 'mousemove'));
      }),
      (b._touchEnd = function (a) {
        e && (f(a, 'mouseup'), f(a, 'mouseout'), this._touchMoved || f(a, 'click'), (e = !1));
      }),
      (b._mouseInit = function () {
        var b = this;
        b.element.bind({ touchstart: a.proxy(b, '_touchStart'), touchmove: a.proxy(b, '_touchMove'), touchend: a.proxy(b, '_touchEnd') }), c.call(b);
      }),
      (b._mouseDestroy = function () {
        var b = this;
        b.element.unbind({ touchstart: a.proxy(b, '_touchStart'), touchmove: a.proxy(b, '_touchMove'), touchend: a.proxy(b, '_touchEnd') }), d.call(b);
      });
  }
})(jQuery);
//touch punch

window.fancy_option_line = {
  type: 'inline',
  touch: false,
  hideScrollbar: true,
  animationEffect: 'zoom-in-out',
  animationDuration: 500,
  clickOutside: 'close',
  hash: false,
  afterShow: function () {},
};

var LazyLoad = {
  init: function () {
    var elements = document.querySelectorAll('[data-lazy]');
    elements.forEach((el) => {
      if (el.getBoundingClientRect().top <= window.innerHeight) {
        if (!el.classList.value.includes('lazy-loaded')) {
          el.classList.add('lazy-loaded');

          if (el.tagName === 'IMG') {
            el.src = el.dataset.lazy;
          } else {
            el.style.backgroundImage = `url('${el.dataset.lazy}')`;
          }
        }
      }
    });
  },
};

class Main {
  Init = () => {
    $('.sec7 .btn').click(function (e) {
      e.preventDefault();
      $('.popup-pano').addClass('active');
    });

    $('.popup-pano .popup-images__close').click(function () {
      $('.popup-pano').removeClass('active');
    });

    $(document).keyup(function (e) {
      if (e.key === 'Escape') {
        $('.popup.p_request .popup_close').trigger('click');
      }
    });

    Site.init();

    Calc.init();

    Gallery.init();

    Adv.start();

    PopupMedia.init();

    Cookie.init();

    const self = this;

    /*let padY = 0;
    $('.appear').appear(function () {
        $(this).addClass('anim');
    }, {accX: 0, accY: padY});*/

    $('html, body').animate(
      {
        scrollTop: 0,
      },
      0,
    );
    window.scrollTo(0, 0);
    $(document).ready(function () {
      setTimeout(function () {
        $('html, body').animate(
          {
            scrollTop: 0,
          },
          0,
        );
        window.scrollTo(0, 0);
      }, 1);
    });

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    self.MobClass();
    $(window).on('resize', function () {
      self.MobClass();
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    if ($('.s_top').length) {
      self.TopSlider();
    }
    if ($('.slider-loc2').length) {
      self.SliderLoc();
    }
    if ($('.sec-8-cont').length) {
      //self.Sec8Slider();
    }
    if ($('.sec12-flat-wrap').length) {
      setTimeout(function () {
        self.FlatsSlider();
      }, 1000);
    }
    if ($('.sale_block').length) {
      self.SaleSlider();
    }
    if ($('.s_din').length) {
      self.BlockDinamic();
    }
    if ($('.s_about_slider').length) {
      self.AboutSlider();
    }
    if ($('#map').length) {
      self.Map();
    }
    if ($('.sec-10-mobslider').length) {
      self.GallerySlider();
    }

    if ($('.sec2__videoWrap video').length) {
      let videoNode = window.document.querySelector('.sec2__videoWrap video');
      let timeNode = window.document.querySelector('.js-video-time');
      videoNode.addEventListener('loadedmetadata', function (e) {
        let duration = videoNode.duration.toFixed(1);
        let m = Math.floor(duration % 60);
        timeNode.innerText = Math.floor(duration / 60) + ':' + (m < 10 ? '0' : '') + m;
      });
    }

    $('.sec2__videoWrap').bind('click', function () {
      $(this).addClass('active');
      let video = $(this).find('video')[0];
      if (video.paused === true) {
        video.play();
      } else {
        video.pause();
      }
    });

    $('.loc_tab').bind('click', function () {
      let id = $(this).attr('data-id');
      $('.loc_tab').removeClass('active');
      $(this).addClass('active');
      $('.loc_tab__content:visible').hide();
      $('.loc_tab__content[data-id=' + id + ']').fadeIn(700);
    });

    $('.anchor').bind('click', function (e) {
      e.preventDefault();
      let href = $(this).attr('href');
      if (!href) href = $(this).attr('data-href');
      if ($(href).length) {
        if (Site.smoother) {
          //Site.smoother.scrollTo($(href).offset().top, false)
          Site.smoother.scrollTo(href, false);

          //$("html, body").animate({ scrollTop: $(href).offset().top }, 0);
        } else {
          $('html, body').animate({ scrollTop: $(href).offset().top }, 0);
        }
      }
    });

    document.addEventListener('click', function (e) {
      let t = $(e.target);
      if (t.closest('.s_din__select').length === 0) {
        $('.s_din__select__val').removeClass('active');
      }
    });

    $('.popup_show').click(function (e) {
      e.preventDefault();

      let id = $(this).attr('href');
      if (!id) id = $(this).attr('data-href');
      if (!id) return false;

      if ($(this).hasClass('popup-img')) {
        $(id)
          .find('img:not(.init)')
          .each(function () {
            $(this).attr('src', $(this).attr('data-src'));
            $(this).addClass('init');
          });
      }

      if ($(id).find('iframe').length && !$(id).hasClass('loaded')) {
        $('body').addClass('wait');
        $(id).addClass('loading');
        //return false;
        setTimeout(function () {
          $(id).removeClass('loading');
          $.fancybox.open($(id), fancy_option_line);
          $('body').removeClass('wait');
          $(id).addClass('loaded');
        }, 1000);
      } else {
        $.fancybox.open($(id), fancy_option_line);

        $('.form .form-error-message').hide();
        $('.form .form__input').removeClass('error');
        $('.form form').show();
        $('.form input').val('');
        $('.p_request .popup__title').html(`
                  обратная связь
                  <div>Заполните заявку и&nbsp;мы свяжемся с&nbsp;вами в&nbsp;ближайшее&nbsp;время</div>
                `);
      }
      return false;
    });

    /*        $('.popup_close').click(function (e) {
                e.preventDefault();
                $(this).parents('.popup').find('[data-fancybox-close]').click();
                //$('body').removeClass('fancybox-active');
            });*/

    $('form .phone input').mask('+7(999) 999-9999', {
      autoclear: true,
      completed: function () {
        validateInput($(this));
      },
    });

    function getFormData(f) {
      let unindexed_array = f.serializeArray();
      let indexed_array = {};
      $.map(unindexed_array, function (n, i) {
        let name = n['name'];
        let value = n['value'];
        if (name.indexOf('[]') != -1) {
          if (!indexed_array[name]) {
            indexed_array[name] = [];
          }
          indexed_array[name].push(value);
        } else {
          indexed_array[name] = value;
        }
      });
      return indexed_array;
    }

    function validateEmail(email) {
      let re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function validateForm(form) {
      let check = true;
      let block_error = form.find('.form-error-message');

      form.find('.req:visible').each(function () {
        if (
          $(this).find('input').val() === '' &&
          $(this).parent('.form__block-file').length &&
          $(this).parent('.form__block-file').find('.form-file-list').html().replace(/\s/g, '') !== ''
        ) {
          return;
        }

        if ($(this).find('input').val() === '') {
          $(this).addClass('error');
          check = false;
        } else if ($(this).find('input[type=checkbox]').length && !$(this).find('input:checked').length) {
          $(this).addClass('error');
          check = false;
        } else if ($(this).find('textarea').val() === '') {
          $(this).addClass('error');
          check = false;
        } else {
          if (
            ($(this).find('input').length && $(this).find('input').val().replace(/\s/g, '') === '') ||
            ($(this).find('textarea').length && $(this).find('textarea').val().replace(/\s/g, '') === '')
          ) {
            $(this).addClass('error');
            check = false;
          } else {
            $(this).removeClass('error');
          }
        }
      });

      if (!check) {
        block_error.html(block_error.html() + block_error.attr('data-mess-empty') + '<br>');
        block_error.slideDown();
      }

      form.find('.email').each(function () {
        if ($(this).hasClass('req') || $(this).find('input').val().length) {
          if (!validateEmail($(this).find('input').val().replace(/\s/g, ''))) {
            $(this).addClass('error');
            if ($(this).hasClass('edited')) {
              $(this).find('[data-mess-email]').slideDown();
            }

            check = false;
          } else {
            $(this).removeClass('error');
          }
        } else {
          $(this).removeClass('error');
        }
      });

      return check;
    }

    function validateInput(input_in) {
      let parent = input_in.parent('.form__input');
      if (parent.hasClass('error')) {
        if (parent.hasClass('req') && input_in.val() !== '') {
          if (parent.hasClass('email')) {
            if (validateEmail(input_in.val())) {
              parent.removeClass('error');
            }
          } else {
            parent.removeClass('error');
          }
        }
      }
    }

    $('.form form').bind('submit', function (e, url_custom) {
      e.preventDefault();

      let f = $(this);
      let url = f.attr('action');
      let block_error = f.find('.form-error-message');
      if (url_custom) {
        url = url_custom;
      }

      block_error.slideUp();
      block_error.html('');
      $('.form__input__mess').slideUp();

      if (!validateForm(f)) {
        e.preventDefault();
        f.find('.error').eq(0).find('input').focus();
        return false;
      }

      if (!f.find('input[name="asc"]').length) {
        f.append('<input hidden type="text" name="asc" value="' + $('body').attr('data-rel') + '">');
      }
      let data = getFormData(f);

      console.log(data);
      self.WaitOn();
      let formData = new FormData(f.get(0));

      // Обработка чекбокса
      formData.delete('agree');
      const checkbox = f.find('input[type=checkbox]');
      if (checkbox) {
        formData.append('agree', checkbox.is(':checked'));
      }
      //

      // Calltouch
      // const fio = document.querySelector("#user_name").value || null;
      const phoneNumber = document.querySelector('#user_phone').value || null;
      const calltouchPhone = phoneNumber.replaceAll(/[^0-9+]/g, '').replaceAll('+', '');

      if (window?.ctw) {
        window.ctw.createRequest('47153', calltouchPhone, [], (success, data) => {
          console.log(success, data);
        });
      }

      $.ajax({
        type: 'POST',
        url: url,
        data: formData,
        contentType: false,
        processData: false,

        success: function (response) {
          console.log(response);
          self.WaitOff();

          if (response.error) {
            block_error.html(response.message);
            block_error.slideDown();
            /*
                                }else if(response.success) {
                                    //location.href = response.url;
                                    f.parents('.popup').find('.popup__title').html(block_error.attr('data-success-title')+'<div>'+block_error.attr('data-success-text')+'</div>');
                                    f.hide();
            */
          } else {
            //block_error.html(block_error.attr('data-mess'));
            //block_error.slideDown();
            f.parents('.popup')
              .find('.popup__title')
              .html(block_error.attr('data-success-title') + '<div>' + block_error.attr('data-success-text') + '</div>');
            f.hide();
          }
        },
        error: function (response) {
          console.log(response);
          self.WaitOff();
          block_error.html(block_error.attr('data-mess'));
          block_error.slideDown();
        },
      });

      return false;
    });
  };

  TopSlider = () => {
    let sl_top = new Swiper('.slider-top', {
      slidesPerView: '1',
      speed: 1000,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      loop: true,
      navigation: {
        nextEl: '.slider-top .sl_arrs .-r',
        prevEl: '.slider-top .sl_arrs .-l',
      },
      on: {
        init: function () {
          let tmpImg = new Image();
          let tmpImgSrc = $('.s_top__item').eq(0).find('.-img').css('background-image');
          tmpImgSrc = tmpImgSrc.replaceAll('url("', '').replaceAll('")', '');
          tmpImg.src = tmpImgSrc;
          tmpImg.onload = function () {
            $('body').addClass('load');
          };
          $('.s_top__item').eq(0).addClass('active');
          setTimeout(function () {
            $('.slider-top').addClass('anim_active');
          }, 1000);
          $('.sl_arr__sep').removeClass('stop');
        },
        slideChange: function (swiper) {
          stop_anim_line();
          $('.s_top__item').removeClass('active');
          $('.s_top__item').eq(swiper.realIndex).addClass('active');
        },
        touchStart: function () {
          //$('.sl_arr__sep').addClass('stop');
        },
        touchEnd: function () {
          //$('.sl_arr__sep').removeClass('stop');
        },
      },
    });

    function stop_anim_line() {
      const slider_arr__sep = $('.sl_arr__sep');
      slider_arr__sep.addClass('stop');
      setTimeout(function () {
        slider_arr__sep.removeClass('stop');
      }, 1000);
    }
  };

  SliderLoc = () => {
    const progressCircle = document.querySelector('.swiper-hero-progress');

    Main.swiper3 = new Swiper('.slider-loc2', {
      loop: true,
      speed: 1000,
      effect: 'creative',
      /*autoplay: {
          delay: 3000,
          disableOnInteraction: true,
      },*/
      //allowTouchMove: false,

      watchSlidesProgress: true,
      creativeEffect: {
        prev: {
          translate: [0, 0, -400],
          opacity: 1,
        },
        next: {
          translate: ['100%', 0, 0],
          opacity: 0,
        },
      },
      navigation: {
        nextEl: '.sec7 .arrow-next',
        prevEl: '.sec7 .arrow-prev',
      },
      on: {
        init: function (s) {
          $('.swiper-progress-anim').removeClass('anim');
          setTimeout(function () {
            $('.swiper-progress-anim').addClass('animStart');
          }, 1);
        },
      },
    });

    Main.swiper3.on('slideChange', function (swiper) {
      $('.sec7 .swiper-progress-anim').removeClass('animStart');
      $('.sec7 .swiper-progress-anim').removeClass('anim');
      setTimeout(function () {
        $('.swiper-progress-anim').addClass('anim');
      }, 2);
      Main.swiper2.slideTo(swiper.realIndex);
    });

    Main.swiper2 = new Swiper('.slider-loc', {
      loop: true,
      effect: 'creative',
      direction: 'vertical',
      speed: 1000,

      allowTouchMove: false,
      creativeEffect: {
        prev: {
          translate: [0, '0%', -1],
        },
        next: {
          translate: [0, '100%', 0],
        },
      },
      pagination: {
        el: '.navi-counter',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.sec7 .arrow-next',
        prevEl: '.sec7 .arrow-prev',
      },
    });
    //swiper2.controller.control = swiper3;
    //swiper3.controller.control = swiper2;
  };

  FlatsSlider = () => {
    let tab_hover_time;
    $('.sec12-tabs div').hover(
      function () {
        if (tab_hover_time) clearTimeout(tab_hover_time);
        $('.sec12-tabs div').removeClass('hover');
        $(this).addClass('hover');
      },
      function () {
        tab_hover_time = setTimeout(function () {
          $('.sec12-tabs div').removeClass('hover');
        }, 300);
      },
    );

    $('.sec12').append('<div class="js-slider-flat1" style="display: none"></div><div class="js-slider-flat2" style="display: none"></div>');
    $('.js-slider-flat1').html($('.slider-flat1 .swiper-wrapper').html());
    $('.js-slider-flat2').html($('.slider-flat2 .swiper-wrapper').html());
    $('.sec12-tabs div').click(function () {
      $(this).toggleClass('active').siblings().removeClass('active');
      let id = [];
      //let sliders_flat = $('.slider-flat1 .swiper-slide');
      //let sliders_plans = $('.slider-flat2 .swiper-slide');
      $('.sec12-tabs div.active').each(function () {
        id.push($(this).attr('data-id'));
      });
      //sliders_flat.addClass('none');
      //sliders_plans.addClass('none');
      let sliders_flat_html = '';
      let sliders_plans = '';
      $('.js-flats-navi').removeClass('none');

      if (id.length) {
        id.forEach((el) => {
          $('.js-slider-flat1 .swiper-slide[data-id="' + el + '"]').each(function () {
            sliders_flat_html += $(this)[0].outerHTML;
          });
          $('.js-slider-flat2 .swiper-slide[data-id="' + el + '"]').each(function () {
            sliders_plans += $(this)[0].outerHTML;
          });
        });
        $('.slider-flat1 .swiper-wrapper').html(sliders_flat_html);
        $('.slider-flat2 .swiper-wrapper').html(sliders_plans);
        if (!sliders_flat_html) {
          $('.js-flats-navi').addClass('none');
        }
      } else {
        //sliders_flat.removeClass('none');
        //sliders_plans.removeClass('none');
        $('.slider-flat1 .swiper-wrapper').html($('.js-slider-flat1').html());
        $('.slider-flat2 .swiper-wrapper').html($('.js-slider-flat2').html());
      }

      swiperFlat1.update();
      swiperFlat2.update();
      swiperFlat1.slideTo(0);
      swiperFlat2.slideTo(0);

      $('.sec12-flat-wrap .btn').click(function () {
        $('header .popup_show').trigger('click');
      });
    });

    let navi_line_flats = $('.js-flats-navi .swiper-progress-anim');

    let swiperFlat1 = new Swiper('.slider-flat1', {
      navigation: {
        nextEl: '.js-flats-navi .arrow-next',
        prevEl: '.js-flats-navi .arrow-prev',
      },
      speed: 1000,
      //autoHeight: true,
      autoplay: false,
      pagination: {
        el: '.flats-navi-counter',
        type: 'fraction',
      },
      on: {
        init: function () {
          $('.sec12-flat-wrap .swiper-progress-anim').removeClass('anim');
          setTimeout(function () {
            $('.sec12-flat-wrap .swiper-progress-anim').addClass('animStart');
          }, 1);

          this.el.addEventListener('mouseenter', () => {
            this.autoplay.stop();
            navi_line_flats.addClass('pause');
            navi_line_flats.removeClass('animStart');
            navi_line_flats.removeClass('anim');
          });

          this.el.addEventListener('mouseleave', () => {
            this.autoplay.start();
            navi_line_flats.removeClass('pause');
            navi_line_flats.addClass('animStart');
          });
        },
      },
      ldirection: 'horizontal',
      breakpoints: {
        1000: {
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            stopOnLastSlide: true,
          },
        },
      },
    });

    swiperFlat1.on('slideChange', function () {
      navi_line_flats.removeClass('animStart');
      navi_line_flats.removeClass('anim');
      setTimeout(function () {
        navi_line_flats.addClass('anim');
      }, 2);
    });

    let swiperFlat2 = new Swiper('.slider-flat2', {
      loop: false,
      ldirection: 'horizontal',
    });

    swiperFlat2.controller.control = swiperFlat1;
    swiperFlat1.controller.control = swiperFlat2;
  };

  GallerySlider = () => {
    Site.galleryslider = new Swiper('.sec-10-mobslider__images .swiper', {
      slidesPerView: 'auto',
      allowTouchMove: true,
      navigation: {
        nextEl: '.gallery-navi .arrow-next',
        prevEl: '.gallery-navi .arrow-prev',
      },
      speed: 1000,
      loop: false,
      loopedSlides: 7,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.gallery-navi-counter',
        type: 'fraction',
      },
      on: {
        init: function () {
          this.autoplay.stop();
        },
        slideChange: function (swiper) {
          let gtindex = swiper.activeIndex;
          $('.sec-10-mobslider__title').removeClass('active');
          $('.sec-10-mobslider__title:eq(' + gtindex + ')').addClass('active');
          let gtshift = 0;
          for (var i = 0; i < gtindex; i++) {
            gtshift -= $('.sec-10-mobslider__title:eq(' + i + ')').outerWidth();
          }
          $('.sec-10-mobslider__titles').css('transform', 'translateX(' + gtshift + 'px)');
        },
      },
    });
  };

  SaleSlider = () => {
    let navi_line_flats = $('.js-slider-sale .swiper-progress-anim');

    let slider = new Swiper('.sale_block .swiper', {
      navigation: {
        nextEl: '.js-slider-sale .arrow-next',
        prevEl: '.js-slider-sale .arrow-prev',
      },
      speed: 1000,
      loop: 'true',
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      on: {
        init: function () {
          navi_line_flats.removeClass('anim');
          setTimeout(function () {
            navi_line_flats.addClass('animStart');
          }, 1);

          this.el.addEventListener('mouseenter', () => {
            this.autoplay.stop();
            navi_line_flats.addClass('pause');
            navi_line_flats.removeClass('animStart');
            navi_line_flats.removeClass('anim');
          });

          this.el.addEventListener('mouseleave', () => {
            this.autoplay.start();
            navi_line_flats.removeClass('pause');
            navi_line_flats.addClass('animStart');
          });
        },
      },
    });

    slider.on('slideChange', function () {
      navi_line_flats.removeClass('animStart');
      navi_line_flats.removeClass('anim');
      setTimeout(function () {
        navi_line_flats.addClass('anim');
      }, 2);
    });
  };

  MobClass = () => {
    $('body').toggleClass('hover', !('ontouchstart' in window || navigator.maxTouchPoints > 0));
  };

  BlockDinamic = () => {
    function init_dinamic() {
      if (!$('section.s_din').length) return;

      const activeYearClass = 's_din__year--active';
      const yearsBlock = $('.s_din__years');
      const yearsItems = yearsBlock.children();
      const yearPreview = $('.s_din__preview');
      const yearPreviewWrap = $('.s_din__preview-wrap');

      if (Site.isMobile) {
        const gap = (16 / 375) * document.documentElement.clientWidth;
        const popupBtn = $('.s_din__progress > .s_din__year-popup-btn');
        new Swiper('.s_din__preview.swiper', {
          speed: 1000,
          loop: true,
          slidesPerView: 1,
          spaceBetween: 16,
          watchOverflow: true,
          on: {
            init(swiper) {
              const activeYear = yearsItems.eq(0).addClass(activeYearClass);
              const yearNumber = activeYear.find('.s_din__year-btn').text();
              popupBtn.toggleClass('-disable', !isFinite(yearNumber)).attr('data-progress-year', yearNumber);

              yearsItems.on('click', function () {
                $(this).siblings().removeClass(activeYearClass);
                swiper.slideToLoop($(this).index());
              });
            },
            slideChangeTransitionStart() {
              const activeYear = yearsItems.eq(this.realIndex);

              if (activeYear.position().left + gap > document.documentElement.clientWidth || activeYear.position().left - gap < 0) {
                yearsBlock.animate(
                  {
                    scrollLeft: activeYear.position().left,
                  },
                  800,
                );
              }
            },
            slideChange() {
              const activeYear = yearsItems.eq(this.realIndex);
              activeYear.addClass(activeYearClass).siblings().removeClass(activeYearClass);

              const yearNumber = activeYear.find('.s_din__year-btn').text();
              popupBtn.toggleClass('-disable', !isFinite(yearNumber)).attr('data-progress-year', yearNumber);
            },
          },
        });
      } else {
        const tl = gsap.timeline();
        const getGapWidth = () => yearsBlock.width() - yearsItems.toArray().reduce((w, el) => w + el.clientWidth, 0);

        function yearSlide(idx) {
          tl.to(yearsItems.toArray(), {
            x: (i) => (i < idx ? -getGapWidth() : 0),
          })
            .to(
              yearPreview,
              {
                x: () => (idx > 0 ? yearsItems[idx].offsetLeft + (20 / 1920) * document.documentElement.clientWidth - yearPreview.width() : 0),
              },
              '<+10%',
            )
            .to(
              yearPreviewWrap,
              {
                x: () => -idx * yearPreview.width(),
              },
              '<',
            );
        }

        yearsItems
          .on('click', function () {
            $(this).addClass(activeYearClass).siblings().removeClass(activeYearClass);
            yearSlide($(this).index());
          })
          .eq(0)
          .addClass(activeYearClass);

        window.addEventListener('resize', () => {
          const idx = yearsItems.filter('.' + activeYearClass).index();
          yearSlide(idx);
        });
      }
    }

    setTimeout(() => {
      init_dinamic();
      PopupMedia.init();
    }, 100);
  };

  AboutSlider = () => {
    let navi_line_flats = $('.js-about_slider_navi .swiper-progress-anim');

    let slider = new Swiper('.s_about_slider .swiper', {
      navigation: {
        nextEl: '.s_about_slider .arrow-next',
        prevEl: '.s_about_slider .arrow-prev',
      },
      speed: 1000,
      slidesPerView: 'auto',
      spaceBetween: 24,
      //loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      on: {
        init: function () {
          navi_line_flats.removeClass('anim');
          setTimeout(function () {
            navi_line_flats.addClass('animStart');
          }, 1);
        },
      },
      breakpoints: {
        1000: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
      },
    });

    ScrollTrigger.create({
      trigger: slider.wrapperEl,
      onEnter() {
        !slider.autoplay.running && slider.autoplay.start()
      }
    })

    slider.autoplay.stop();

    slider.on('slideChange', function () {
      navi_line_flats.removeClass('animStart');
      navi_line_flats.removeClass('anim');
      setTimeout(function () {
        navi_line_flats.addClass('anim');
      }, 1);
    });
  };

  Map = () => {
    //if(typeof ymaps == 'undefined') return false;
    const latlng = $('.map').attr('data-coords').split(',');
    ymaps.ready(function () {
      const map = new ymaps.Map('map', {
        center: latlng,
        zoom: 15,
        controls: [],
      });

      map.behaviors.disable(['scrollZoom']);

      const marker = new ymaps.Placemark(
        latlng,
        {
          hintContent: '',
          balloonContent: '',
        },
        {
          iconLayout: 'default#image',
          iconImageHref: '/src/img/marker.svg',
          iconImageSize: [79, 138],
          iconImageOffset: [-39, -138],
        },
      );

      //m.setCenter(latlng)

      map.geoObjects.add(marker);

      /*            var pixelCenter = map.getGlobalPixelCenter(latlng);
      
                  pixelCenter = [
                      pixelCenter[0] - 420,
                      pixelCenter[1]
                  ];
                  var geoCenter = map.options.get('projection').fromGlobalPixels(pixelCenter, map.getZoom());
      
                  map.setCenter(geoCenter);*/
    });
  };

  WaitOn = () => {
    $('body').addClass('wait');
  };

  WaitOff = () => {
    $('body').removeClass('wait');
  };
}

const Site = {
  isMobile: window.innerWidth <= 1000,
  prevScroll: 0,
  init: () => {
    $('.menu__close').click(function () {
      $('.menu').removeClass('active');
    });

    $('.m_burger').click(function () {
      $('.menu').addClass('active');
    });

    gsap.registerPlugin(window.ScrollTrigger, window.ScrollSmoother);

    if (Site.isMobile) {
      Site.initMobile();
    } else {
      Site.initDesctope();
    }

    var st;
    window.onresize = function () {
      clearTimeout(st);
      st = setTimeout(Site.resize, 100);
    };

    /*Fancybox.bind('[data-fancybox="gallery"]', {
      buttons: [
        'close'
      ]
    });*/

    $(window).scroll(function () {
      const scr = parseInt(window.scrollY);

      if (scr >= Site.prevScroll && scr >= 50) {
        $('header').addClass('hide');
      } else {
        $('header').removeClass('hide');
      }

      if (scr > window.innerHeight) {
        $('header').addClass('diff');
      } else {
        $('header').removeClass('diff');
      }

      Site.prevScroll = scr;
    });

    $('footer .logo').click(function () {
      if (Site.smoother) {
        Site.smoother.scrollTo(0, false);
      }
    });
  },
  resize: function () {
    var m = window.innerWidth <= 1000;

    if (Site.isMobile != m) {
      Site.isMobile = m;

      if (Site.isMobile) {
        Site.initMobile();
      } else {
        Site.initDesctope();
      }

      location.reload();
    }
  },
  initMobile: () => {
    LazyLoad.init();

    $(window).scroll(function () {
      LazyLoad.init();
    });

    const animTitle = document.querySelectorAll('.anim-title');
    if ($('.sec-8-cont').length) {
      if (window.slider_sec8) {
        window.slider_sec8.destroy();
      }
      Site.Sec8Slider();
    }
    animTitle.forEach((item) => {
      window.gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top center+=' + window.innerHeight / 3,
          end: '+=' + window.innerHeight,
          scrub: true,
          onEnter: function (s) {
            item.classList.add('active');
          },
        },
      });
    });

    window.gsap.to('.section6', {
      scrollTrigger: {
        trigger: '.section6',
        start: 'top top',
        end: '+=' + window.innerHeight,
        scrub: true,
        onEnter: function (s) {
          if (Site.galleryslider) {
            Site.galleryslider.autoplay.start();
          }
        },
      },
    });

    $('.menu__list div').click(function () {
      const index = $(this).index();
      $('.menu').removeClass('active');
      if (index == 0) {
        $('.section2')[0].scrollIntoView();
      }
      if (index == 1) {
        $('.section3')[0].scrollIntoView();
      }
      if (index == 2) {
        $('.section4-title')[0].scrollIntoView();
      }
      if (index == 3) {
        $('.section6')[0].scrollIntoView();
      }
      if (index == 4) {
        $('.section7')[0].scrollIntoView();
      }
      if (index == 5) {
        $('.calc')[0].scrollIntoView();
      }
      if (index == 6) {
        $('.s_din')[0].scrollIntoView();
      }
      if (index == 7) {
        $('.s_about')[0].scrollIntoView();
      }
      setTimeout(function () {
        $('header').addClass('hide');
      }, 100);
    });

    window.gsap.to('.sec3__img', {
      scrollTrigger: {
        trigger: '.sec3__img',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });

    window.gsap.to('.sec__4-img div', {
      scrollTrigger: {
        trigger: '.sec__4-img',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '15%',
    });

    window.gsap.to('.se4__img3 div', {
      scrollTrigger: {
        trigger: '.se4__img3',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      scale: 1,
      width: '100%',
    });
    window.gsap.to('.se4__img2 img:first-child, .se4__img2 img:last-child', {
      scrollTrigger: {
        trigger: '.se4__img2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });
    window.gsap.to('.se4__img2 img:nth-child(2)', {
      scrollTrigger: {
        trigger: '.se4__img2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '10%',
    });

    const sec6Text = document.querySelectorAll('.sec6-text-flex-wrap');
    sec6Text.forEach((item) => {
      window.gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top center+=' + window.innerHeight / 3,
          end: '+=' + window.innerHeight,
          scrub: true,
          onEnter: function (s) {
            item.classList.add('active');
          },
        },
      });
    });

    window.gsap.to('.section4-title', {
      scrollTrigger: {
        trigger: '.section4-title',
        start: 'top center',
        end: '+=' + window.innerHeight,
        scrub: true,
        onEnter: function () {
          document.querySelector('.section4').classList.add('active');
        },
      },
    });

    /*window.gsap.to(".section4", {
      scrollTrigger: {
        trigger: '.section4',
        start: 'top top',
        end: '+=' + window.innerHeight*2,
        scrub: true,
        pin: true
      }
    });

    window.gsap.to(".sec-8-cont .swiper-wrapper", {
      scrollTrigger: {
        trigger: '.section4',
        start: 'top top',
        end: '+=' + window.innerHeight*2,
        scrub: true,
      },
      duration: .6,
      x: "-86%",
    });*/

    window.gsap.to('.section4 .sec_lines img:first-child, .section4 .sec_lines img:last-child', {
      scrollTrigger: {
        trigger: '.sec_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.section4 .sec_lines img:nth-child(2)', {
      scrollTrigger: {
        trigger: '.sec_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '10%',
    });

    window.gsap.to('.sec11-img-1 div', {
      scrollTrigger: {
        trigger: '.sec11-img-1',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2,
        scrub: true,
      },
      duration: 0.6,
      scale: 1,
    });

    window.gsap.to('.sec11-img-2 div', {
      scrollTrigger: {
        trigger: '.sec11-img-2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.set('.din_lines', { '--progress': 0 });
    window.gsap.to('.din_lines', {
      scrollTrigger: {
        trigger: '.din_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      '--progress': 1,
    });
  },
  Sec8Slider: () => {
    window.slider_sec8 = new Swiper('.sec-8-cont .swiper', {
      slidesPerView: 1,
      //speed: 1000,
      spaceBetween: 0,
      allowTouchMove: true,
      breakpoints: {
        1001: {
          slidesPerView: 3,
        },
      },
      on: {
        init: function () {},
        slideChange: function (swiper) {
          window.gsap.killTweensOf(document.querySelector('.sec-8-cont .swiper-wrapper'));
        },
      },
    });
  },
  initDesctope: () => {
    const self = this;
    if ($('.sec-8-cont').length) {
      if (window.slider_sec8) {
        window.slider_sec8.destroy();
      }
      Site.Sec8Slider();
    }
    Site.smoother = ScrollSmoother.create({
      smooth: 2,
      smoothTouch: 2,
      normalizeScroll: true,
      onUpdate: function (s) {
        LazyLoad.init();
      },
    });

    $('.menu__list div').click(function () {
      const index = $(this).index();
      $('.menu').removeClass('active');
      if (index == 0) {
        Site.smoother.scrollTo('.section2');
      }
      if (index == 1) {
        Site.smoother.scrollTo('.section3');
      }
      if (index == 2) {
        Site.smoother.scrollTo('.section4-title');
      }
      if (index == 3) {
        Site.smoother.scrollTo('.section6');
      }
      if (index == 4) {
        Site.smoother.scrollTo('.section7');
      }
      if (index == 5) {
        Site.smoother.scrollTo('.calc');
      }
      if (index == 6) {
        Site.smoother.scrollTo('.s_din');
      }
      if (index == 7) {
        Site.smoother.scrollTo('.s_about');
      }
      setTimeout(function () {
        $('header').addClass('hide');
      }, 100);
    });

    window.gsap.to('.sec3__img span', {
      scrollTrigger: {
        trigger: '.sec3__img',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      width: 0,
    });

    const animTitle = document.querySelectorAll('.anim-title');
    animTitle.forEach((item) => {
      window.gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top center+=' + window.innerHeight / 3,
          end: '+=' + window.innerHeight,
          scrub: true,
          onEnter: function (s) {
            item.classList.add('active');
          },
        },
      });
    });

    window.gsap.to('.sec2__subTitle div:last-child', {
      scrollTrigger: {
        trigger: '.sec2__subTitle',
        start: 'top bottom',
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      x: '115%',
    });

    window.gsap.to('.sec__4-img div', {
      scrollTrigger: {
        trigger: '.sec__4-img',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '15%',
    });

    window.gsap.to('.sec4__text', {
      scrollTrigger: {
        trigger: '.sec4__text',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });

    window.gsap.to('.se4__img3 div', {
      scrollTrigger: {
        trigger: '.se4__img3',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      scale: 1,
      width: '100%',
    });

    window.gsap.to('.se4__img2 img:first-child, .se4__img2 img:last-child', {
      scrollTrigger: {
        trigger: '.se4__img2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.se4__img2 img:nth-child(2)', {
      scrollTrigger: {
        trigger: '.se4__img2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '10%',
    });

    window.gsap.to('.sec4-wrap-center > div:nth-child(2n)', {
      scrollTrigger: {
        trigger: '.sec4-wrap-center',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      y: '50%',
    });

    window.gsap.to('.sec4-wrap-center > div:nth-child(2n+1)', {
      scrollTrigger: {
        trigger: '.sec4-wrap-center',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      y: '-50%',
    });

    window.gsap.to('.sec5-img > span', {
      scrollTrigger: {
        trigger: '.sec5-img',
        start: 'top center-=' + window.innerHeight / 6,
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      y: '-100%',
      x: '-100%',
    });

    const sec6Text = document.querySelectorAll('.sec6-text-flex-wrap');
    sec6Text.forEach((item) => {
      window.gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top center+=' + window.innerHeight / 3,
          end: '+=' + window.innerHeight,
          scrub: true,
          onEnter: function (s) {
            item.classList.add('active');
          },
        },
      });
    });

    window.gsap.to('.sec7 .slider-loc2', {
      scrollTrigger: {
        trigger: '.sec7',
        start: 'top bottom-=' + window.innerHeight / 5,
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });

    window.gsap.to('.sec7', {
      scrollTrigger: {
        trigger: '.sec7',
        start: 'top center',
        end: '+=' + window.innerHeight,
        scrub: true,
        onEnter: function (s) {
          Main.swiper3.params.autoplay = {
            delay: 3000,
            disableOnInteraction: true,
          };

          Main.swiper3.autoplay.start();
        },
      },
    });

    window.gsap.to('.slider-loc__bg', {
      scrollTrigger: {
        trigger: '.sec7',
        start: 'top bottom-=' + window.innerHeight / 4,
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      scaleX: 0,
    });

    window.gsap.to('.section4-title', {
      scrollTrigger: {
        trigger: '.section4-title',
        start: 'top center',
        end: '+=' + window.innerHeight,
        scrub: true,
        onEnter: function () {
          document.querySelector('.section4').classList.add('active');
        },
      },
    });

    window.gsap.to('.section4', {
      scrollTrigger: {
        trigger: '.section4',
        start: 'top top',
        end: '+=' + window.innerHeight / 2,
        scrub: true,
        pin: true,
        /*              onLeave: function(s){
                          window.gsap.killTweensOf(document.querySelector('.section4'));
                          $('.section4').attr('style','');
                      },*/
      },
    });
    window.gsap.to('.sec-8-cont .swiper-wrapper', {
      scrollTrigger: {
        trigger: '.section4',
        start: 'top top',
        end: '+=' + window.innerHeight,
        scrub: true,
        /*              onLeave: function(s){
                          window.gsap.killTweensOf(document.querySelector('.sec-8-cont .swiper-wrapper'));
                          $('.sec-8-cont .swiper-wrapper').attr('style','');
                      },*/
      },
      duration: 0.6,
      x: '-72%',
    });

    window.gsap.to('.section4 .sec_lines img:first-child, .section4 .sec_lines img:last-child', {
      scrollTrigger: {
        trigger: '.sec_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.section4 .sec_lines img:nth-child(2)', {
      scrollTrigger: {
        trigger: '.sec_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2.5,
        scrub: true,
      },
      duration: 0.6,
      x: '10%',
    });

    window.gsap.to('.sec-9 div', {
      scrollTrigger: {
        trigger: '.section5',
        start: 'top top+=' + window.innerHeight,
        end: '+=' + window.innerHeight * 2,
        scrub: true,
        onEnter: function () {
          //document.querySelector('.section4').classList.add('loaded');
          //console.log(window.gsap);
          /*
                        window.gsap.killTweensOf(document.querySelector('.section4'));
                        window.gsap.killTweensOf(document.querySelector('.section4-title'));
          */
          //Main.Sec8Slider();
        },
        onLeave: function (s) {
          /*              if(!$('.section4').hasClass('inited')){
                            window.gsap.killTweensOf(document.querySelector('.sec-8-cont .swiper-wrapper'));
                            window.gsap.killTweensOf(document.querySelector('.section4'));
                            //window.gsap.killTweensOf(document.querySelector('.section5'));
                            $('.section4').attr('style','');
                            //$('.sec-8-cont .swiper-wrapper').attr('style','');
                            $('.pin-spacer').attr('style','');
                            //$(window).scrollTo(0, $(window).scrollTop() - window.innerHeight)
                            Site.smoother.scrollTo('.section5');
                            Site.smoother.scrollTo('.section6');
          
          
                            Site.Sec8Slider();
                            $('.section4').addClass('inited');
          
                          /!*  window.gsap.to(".section4", {
                                scrollTrigger: {
                                    trigger: '.section4',
                                    start: 'top top',
                                    end: '+=' + window.innerHeight,
                                    scrub: true,
                                    pin: false,
                                }
                            });*!/
                        }*/
        },
      },
      duration: 0.6,
      scale: 1,
    });

    const sec10elements = document.querySelectorAll('.sec-10-left-item');
    sec10elements.forEach((item) => {
      window.gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top center+=' + window.innerHeight / 3,
          end: '+=' + window.innerHeight,
          scrub: true,
          onEnter: function (s) {
            item.classList.add('active');
          },
        },
      });
    });

    window.gsap.to('.sec11-img-1 div', {
      scrollTrigger: {
        trigger: '.sec11-img-1',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2,
        scrub: true,
      },
      duration: 0.6,
      scale: 1,
    });

    window.gsap.to('.sec11-img-2 div', {
      scrollTrigger: {
        trigger: '.sec11-img-2',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 2,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.din_lines', {
      scrollTrigger: {
        trigger: '.din_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '-10%',
    });

    window.gsap.to('.din_lines img:nth-child(2)', {
      scrollTrigger: {
        trigger: '.din_lines',
        start: 'top bottom',
        end: '+=' + window.innerHeight * 1.5,
        scrub: true,
      },
      duration: 0.6,
      x: '10%',
    });

    window.gsap.to('.s_about_slogon', {
      scrollTrigger: {
        trigger: '.s_about_slogon',
        start: 'top bottom',
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });

    window.gsap.to('.s_about_info', {
      scrollTrigger: {
        trigger: '.s_about_info',
        start: 'top bottom',
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      y: 0,
    });

    window.gsap.to('.s_contacts__info', {
      scrollTrigger: {
        trigger: '.s_contacts__info',
        start: 'top bottom',
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });

    window.gsap.to('.sec7-wrap-center .sec4-wrap-item', {
      scrollTrigger: {
        trigger: '.sec7-wrap-center',
        start: 'top bottom',
        end: '+=' + window.innerHeight / 2,
        scrub: true,
      },
      duration: 0.6,
      y: 0,
    });

    window.gsap.to('.sec12-flat-wrap .slider-flat1', {
      scrollTrigger: {
        trigger: '.sec12-flat-wrap .slider-flat1',
        start: 'top bottom',
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });

    window.gsap.to('.sale_block', {
      scrollTrigger: {
        trigger: '.sale_block',
        start: 'top bottom',
        end: '+=' + window.innerHeight,
        scrub: true,
      },
      duration: 0.6,
      x: 0,
    });
  },
};

const Calc = {
  init: function () {
    Calc.frmt = new Intl.NumberFormat();

    $.ajax({
      url: '/api/?w=credit_info',
      // For DEV purpose
      // url: './src/ajax/mortgage.json',
      method: 'get',
      contentType: 'application/json',
      dataType: 'json',
      success: function (response) {
        if (response.success) {
          Calc.bank = 0;
          Calc.type = 0;

          $('.calc__slider[data-name="price"]').attr('data-min', response.data.price[0]);
          $('.calc__slider[data-name="price"]').attr('data-max', response.data.price[1]);

          Calc.price = response.data.price_default;

          $('.calc__slider[data-name="first"]').attr('data-min', Math.ceil(response.data.price[0] / 10));
          $('.calc__slider[data-name="first"]').attr('data-max', response.data.first[1]);

          Calc.first = response.data.first_default;

          $('.calc__slider[data-name="period"]').attr('data-min', response.data.period[0]);
          $('.calc__slider[data-name="period"]').attr('data-max', response.data.period[1]);

          Calc.period = response.data.period_default;

          $('.calc__slider').each(function () {
            const name = $(this).attr('data-name');
            const value = $(this).parent().prev('.calc__value');
            const min = parseInt($(this).data('min'));
            const max = parseInt($(this).data('max'));
            $(this).slider({
              min,
              max,
              value: Calc[name],
              create: function (event, ui) {
                if (name == 'period') {
                  value.html(Calc.frmt.format(Calc[name]) + ' ' + Calc.declOfNum(Calc[name], ['год', 'года', 'лет']));
                } else {
                  value.html(Calc.frmt.format(Calc[name]) + ' ₽');
                }
              },
              change: function (event, ui) {
                Calc.getPrograms();
              },
              slide: function (event, ui) {
                Calc[name] = ui.value;

                if (name == 'period') {
                  value.html(Calc.frmt.format(ui.value) + ' ' + Calc.declOfNum(ui.value, ['год', 'года', 'лет']));
                } else {
                  value.html(Calc.frmt.format(ui.value) + ' ₽');
                }
              },
            });
          });

          for (let key in response.data.banks) {
            $('.calc__select select[name="banks"]').append('<option value="' + key + '">' + response.data.banks[key] + '</option>');
          }

          for (let key in response.data.types) {
            $('.calc__select select[name="types"]').append('<option value="' + key + '">' + response.data.types[key] + '</option>');
          }

          $('.calc__select select').each(function () {
            const name = $(this).attr('name');
            $(this).selectmenu({
              change: function (event, ui) {
                if (name == 'banks') {
                  Calc.bank = ui.item.value;
                }
                if (name == 'types') {
                  Calc.type = ui.item.value;
                }

                Calc.getPrograms();
              },
              open: function () {
                if (Site.smoother) {
                  Site.smoother.paused(true);
                }
              },
              close: function () {
                if (Site.smoother) {
                  Site.smoother.paused(false);
                }
              },
            });
          });

          Calc.getPrograms();

          $('.calc__btn .btn').click(function () {
            Calc.max = Calc.max + 5;
            Calc.renderPrograms();
          });
        }
      },
    });
  },
  declOfNum: function (number, titles) {
    var cases = [2, 0, 1, 1, 1, 2];
    return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
  },
  max: 5,
  data: null,
  getPrograms: function () {
    const data = {
      period: Calc.period,
      price: Calc.price,
      first: Calc.first,
    };

    if (Calc.type && Calc.type != 0) {
      data.type = Calc.type;
    }

    if (Calc.bank && Calc.bank != 0) {
      data.bank = Calc.bank;
    }

    $.ajax({
      url: '/api/?w=credit',
      method: 'get',
      contentType: 'application/json',
      dataType: 'json',
      data,
      success: function (response) {
        if (response.success) {
          Calc.max = 5;
          Calc.data = response.data;
          Calc.renderPrograms();
        }
      },
    });
  },
  renderPrograms: function () {
    if (Calc.data.length <= Calc.max) {
      $('.calc__btn').addClass('hide');
    } else {
      $('.calc__btn').removeClass('hide');
    }

    $('.calc table tbody').children().remove();
    Calc.data.forEach((item, index) => {
      const specialRate = item.special_rate ? ` <span>на ${item.special_rate_period}</span>` : '';
      if (index <= Calc.max) {
        $('.calc table tbody').append(
          `<tr>
            <td>
              <img src="${item.bankLogo}">
            </td>
            <td>${item.rate}${specialRate}</td>
            <td>${item.period}</td>
            <td>${Calc.frmt.format(item.amount)} ₽</td>
            <td>
              <div class="btn -fill"><span>оставить заявку</span></div>
            </td>
          </tr>`,
        );
      }
    });

    $('.calc table .btn').click(function () {
      $('header .popup_show').trigger('click');
    });
  },
};

const Gallery = {
  imgs: [],
  titles: null,
  swiper: null,
  init: function () {
    $('.sec-10 .sec-10-left-item,.sec-10-mobslider__images .sec-10-left-item-bg').click(function () {
      const imgs = $(this).attr('data-src').split('|');
      const title = $(this).find('.sec10-item-title-hidden').text();
      $('.popup-images[data-type="gallery"] .popup-images__title').text(title);
      Gallery.imgs = [];
      Gallery.imgs = imgs;
      Gallery.titles = null;
      Gallery.show();
    });

    $('.popup-images[data-type="gallery"] .popup-images__close').click(function () {
      Gallery.hide();
    });

    $('.sec-10-mobslider__title').click(function () {
      $('.sec-10-mobslider__images .swiper-slide:eq(' + $(this).index() + ') .sec-10-left-item-bg').click();
    });
  },
  setIndex: function (index) {
    $('.popup-images[data-type="gallery"] .popup-images__arrows span').text(index + 1 + '/' + Gallery.imgs.length);

    if (Array.isArray(Gallery.titles)) {
      $('.popup-images[data-type="gallery"] .popup-images__title').text(Gallery.titles[index]);
    }
  },
  show: function () {
    $('.popup-images[data-type="gallery"] .swiper-wrapper').children().remove();

    Gallery.imgs.forEach((item) => {
      $('.popup-images[data-type="gallery"] .swiper-wrapper').append(
        `
        <div class="swiper-slide">
          <div class="popup-images__slide">
            <div style="background-image: url('${item}')"></div>
          </div>
        </div>
        `,
      );
    });

    Gallery.swiper = new Swiper('.popup-images[data-type="gallery"] .swiper', {
      loop: false,
      centeredSlides: true,
      slidesPerView: 'auto',
      /*pagination: {
        el: '.popup-images[data-type="gallery"] .popup-images__pagination',
        clickable: true,
      },*/
      navigation: {
        nextEl: '.popup-images[data-type="gallery"] .popup-images__arrows div:last-child',
        prevEl: '.popup-images[data-type="gallery"] .popup-images__arrows div:first-child',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      on: {
        slideChange: function (e) {
          Gallery.setIndex(e.activeIndex);
        },
        afterInit: function () {
          $('.popup-images[data-type="gallery"]').addClass('active');
        },
      },
    });

    Gallery.setIndex(0);
  },
  hide: function () {
    Gallery.swiper.destroy();
    Gallery.swiper = null;
    Gallery.titles = null;
    Gallery.imgs = [];
    $('.popup-images[data-type="gallery"]').removeClass('active');
  },
};

const Adv = {
  swiper: null,
  isInit: false,
  start: function () {
    $('.popup-images[data-type="adv"] .popup-images__close').click(function () {
      $('.popup-images[data-type="adv"]').removeClass('active');
    });

    $('.section4 .swiper-slide').click(function () {
      if (!Adv.isInit) {
        Adv.init();
      }

      $('.popup-images[data-type="adv"]').addClass('active');
      const index = $(this).index();
      Adv.setIndex(index);
    });
  },
  init: function () {
    Adv.isInit = true;

    $('.section4 .swiper-slide').each(function (index) {
      const imgs = $(this).attr('data-src').split('|');
      const title = $(this).find('.sec-8-cont-item-text').text();
      const dsc = $(this).attr('data-dsc');

      let sIn = '';
      imgs.forEach((item) => {
        sIn += `
          <div>
            <div class="popup-images__adv-inner-slide" style="background-image: url('${item}')"></div>
          </div>
        `;
      });

      $('.popup-images[data-type="adv"] .swiper-outer .swiper-wrapper').append(`
        <div class="swiper-slide">
          <div class="popup-images__adv-outer-slide">
            <div class="popup-images__adv-block">
              <div class="popup-images__title">${title}</div>
              <div class="popup-images__dsc">${dsc}</div>
            </div>

            <div class="slick-inner" data-id="${index}">
              ${sIn}
            </div>
          </div>
        </div>`);
    });

    Adv.swiper = new Swiper('.popup-images[data-type="adv"] .swiper-outer', {
      loop: false,
      speed: 900,
      autoHeight: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        nextEl: '.popup-images[data-type="adv"] .popup-images__arrows div:last-child',
        prevEl: '.popup-images[data-type="adv"] .popup-images__arrows div:first-child',
      },
      on: {
        slideChange: function (e) {
          Adv.setIndex(e.activeIndex);
        },
        afterInit: function () {
          $('.popup-images[data-type="adv"] .slick-inner').each(function () {
            $(this).slick({
              dots: true,
              infinite: false,
              variableWidth: true,
              slidesToShow: 1,
              arrows: false,
            });
          });
        },
      },
      breakpoints: {
        1000: {
          autoHeight: false,
        },
      },
    });
  },
  setIndex: function (index) {
    Adv.swiper.slideTo(index, 0);
    $('.popup-images[data-type="adv"] .popup-images__arrows span').text(index + 1 + '/' + $('.section4 .swiper-slide').length);
  },
};

const PopupMedia = {
  video: null,
  player: null,
  init: function () {
    $('[media-popup-src]')
      .unbind('click')
      .bind('click', function () {
        const popupType = $(this).attr('data-type');
        if (popupType === 'progress') {
          let state = {
            year: undefined,
            month: undefined,
            yearData: undefined,
            slider: undefined,
          };
          state = new Proxy(state, {
            set(target, key, value) {
              target[key] = value;
              switch (key) {
                case 'month':
                  changeTitle();
                  updateSlider();
                  break;
                case 'year':
                  changeTitle();
                  changeYear();
                  break;
              }
              Reflect.set(...arguments);
              return true;
            },
          });

          function changeTitle() {
            $('.popup-images[data-type="progress"] .popup-images__title').text(`${state.month} - ${state.year}`);
          }

          function updateSlider() {
            const slides = state.yearData.find((year) => state.month === year.month)?.items;
            if (!slides) return;

            const sliderEl = $('.popup-images[data-type="progress"] .swiper');
            const sliderWrapper = $('.popup-images[data-type="progress"] .swiper-wrapper');

            if (state.slider) {
              state.slider.destroy(true, true);
            }

            sliderWrapper.empty().html(
              slides.reduce(
                (str, item) =>
                  (str += `<div class="swiper-slide">
                            <div class="popup-images__slide">
                              <div style="background-image: url('${item}')"></div>
                            </div>
                          </div>`),
                '',
              ),
            );

            const gap = (size) => (size / (Site.isMobile ? 375 : 1920)) * document.documentElement.clientWidth;
            state.slider = new Swiper(sliderEl.get(0), {
              slidesPerView: 1,
              spaceBetween: Site.isMobile ? gap(16) : gap(56),
              loop: false,
              navigation: {
                nextEl: '.popup-images[data-type="progress"] .popup-images__arrows .arrow-next',
                prevEl: '.popup-images[data-type="progress"] .popup-images__arrows .arrow-prev',
              },
              keyboard: {
                enabled: true,
                onlyInViewport: true,
              },
              pagination: {
                el: '.popup-images[data-type="progress"] .popup-images__arrows span',
                type: 'custom',
                renderCustom(swiper, current, total) {
                  return `${current}/${total}`;
                },
              },
              on: {
                afterInit: function (e) {
                  $('.popup-images[data-type="progress"]').addClass('active');
                },
              },
            });
          }

          function changeYear() {
            const currentYearOption = $('.popup-images__select select[name="year"] option')
              .attr('selected', false)
              .filter((_, o) => $(o).attr('value') == state.year)
              .attr('selected', true);

            try {
              state.yearData = JSON.parse($(currentYearOption).attr('data-progress-data'));
              state.month = state.yearData[0].month;
              updateMonths();
            } catch (e) {
              console.error(e);
            }
          }

          function updateMonths() {
            $('.popup-images__select select[name="month"]').empty();
            for (let key of state.yearData) {
              $('.popup-images__select select[name="month"]').append(`<option value="${key.month}" data-progress-images="${key.items}">${key.month}</option>`);
            }
            $('.popup-images__select select[name="month"]').selectmenu().selectmenu('refresh', true);
          }

          state.year = $(this).attr('data-progress-year');

          try {
            $('.popup-images__select select').each(function () {
              const name = $(this).attr('name');
              $(this).selectmenu({
                classes: {
                  'ui-selectmenu-menu': 'progress-select',
                  'ui-selectmenu-icon': 'progress-select-icon',
                  'ui-selectmenu-button': 'progress-select-button',
                },
                change: function (event, ui) {
                  if (name === 'year') {
                    state.year = ui.item.value;
                  }
                  if (name === 'month') {
                    state.month = ui.item.value;
                  }
                },
                open: function () {
                  if (Site.smoother) {
                    Site.smoother.paused(true);
                  }
                },
                close: function () {
                  if (Site.smoother) {
                    Site.smoother.paused(false);
                  }
                },
              });
            });
          } catch (e) {
            console.error(e);
          }

          $('.popup-images[data-type="progress"] .popup-images__close').on('click', function () {
            PopupMedia.video = null;
            $('.popup-images[data-type="progress"]').removeClass('active');
            $('.popup-image__media iframe').remove();
            $('.popup-image__media video').remove();
            try {
              state.slider?.destroy(true, true);
              $('.popup-images__select select').each(function () {
                $(this).selectmenu('destroy');
              });
            } catch (e) {
              // console.error(e)
            }
          });

          // $('.popup-images[data-type="progress"]').addClass('active');
        } else if (popupType === 'photo') {
          const index = $(this).index();
          const imgs = $(this).attr('media-popup-src').split('|');
          const title = $(this).find('.s_din__item__title').text();
          $('.popup-images[data-type="gallery"] .popup-images__title').text(title);

          Gallery.imgs = [];
          Gallery.titles = null;
          Gallery.imgs = imgs;
          Gallery.show();
        } else {
          const src = $(this).attr('media-popup-src');
          $('.popup-image__media').removeAttr('style');
          $('.popup-image__media').children().remove();

          if ($(this).attr('media-popup-src').indexOf('.m3u8') != -1) {
            $('.popup-image__media-title').text('Трансляции');
            $('.popup-image__media')
              .append(
                `
            <video id="my-video" class="video-js vjs-default-skin" controls preload="auto" data-setup='{"fluid": true}'>
              <source src="${src}" type="application/x-mpegURL" />
            </video>
            `,
              )
              .addClass('-broadcast');
            if (PopupMedia.player) {
              PopupMedia.player.dispose();
            }
            PopupMedia.player = videojs('my-video');
            PopupMedia.player.play();
          } else if ($(this).attr('media-popup-src').indexOf('.mp4') != -1) {
            $('.popup-image__media-title').text('Ви��ео');
            $('.popup-image__media').append(
              `
            <video loop>
              <source src="${src}" type="video/mp4">
            </video>
            <div class="popup-image__media-btn">
              <svg width="104" height="104" viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M38 31C38 42.598 50.9838 52 67 52C50.9838 52 38 61.402 38 73" stroke="#CFC7BF" stroke-width="2"/>
                <rect x="1" y="1" width="102" height="102" stroke="#CFC7BF" stroke-width="2"/>
              </svg>
            </div>
            `,
            );

            PopupMedia.video = document.querySelector('.popup-image__media video');

            $('.popup-image__media-btn').click(function () {
              $(this).hide();
              PopupMedia.video.play();
            });
          } else if ($(this).attr('media-popup-src').indexOf('www.youtube.com') != -1) {
            $('.popup-image__media-title').text('Видео');
            $('.popup-image__media').append(
              `
            <iframe width="560" height="315" src="${src}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            `,
            );
          } else {
            $('.popup-image__media-title').text('Фото');
            $('.popup-image__media').css({ 'background-image': `url('${src}')` });
          }

          $('.popup-images[data-type="media"]').addClass('active');
        }
      });

    $('.popup-images[data-type="media"] .popup-images__close').click(function () {
      PopupMedia.video = null;
      $('.popup-image__media iframe').remove();
      $('.popup-image__media video').remove();
      $('.popup-images[data-type="media"]').removeClass('active');
    });
  },
};

const Cookie = {
  init: function () {
    if (!localStorage.getItem('scookie')) {
      $('.cookie').addClass('active');
    }

    $('.cookie').click(function () {
      $('.cookie').removeClass('active');
      localStorage.setItem('scookie', 'true');
    });
  },
};

export default new Main();
